const { CarouselElement } = window.BAO.Carousel

export class SplitHeroCarousel extends CarouselElement {
  static get requiredElements () {
    return ['slider', 'slide', 'previous', 'next']
  }

  get isMobile () {
    return window.matchMedia('(max-width: 767px)').matches
  }

  get isStacked () {
    return this.dataset.mobileStack === 'true' && this.isMobile
  }

  async connectedCallback () {
    await super.connectedCallback()

    this.mobileQuery = window.matchMedia('(max-width: 767px)')
    this.mobileQuery.addEventListener('change', this.handleBreakpointChange)
  }

  disconnectedCallback () {
    this.mobileQuery?.removeEventListener('change', this.handleBreakpointChange)
    this.carousel?.destroy()
    super.disconnectedCallback?.()
  }

  // Keen's `enabled: false` doesn't stop dragging, so when stacked there is
  // no carousel at all
  async initialiseCarousel () {
    if (this.isStacked) return null

    return super.initialiseCarousel()
  }

  // Slides hidden at the current breakpoint are left out of Keen so they
  // can't add scroll steps, so it has to be rebuilt when the breakpoint changes
  handleBreakpointChange = async () => {
    this.carousel?.destroy()
    this.carousel = null

    if (this.isStacked || this.isInitialising) return

    this.isInitialising = true
    this.carousel = await this.initialiseCarousel()
    this.isInitialising = false
  }

  get visibleSlides () {
    return this.els.slide.elements.filter(
      slide => getComputedStyle(slide).display !== 'none',
    )
  }

  get options () {
    return {
      selector: this.visibleSlides,
      slides: {
        perView: 'auto',
      },
    }
  }

  get plugins () {
    return [this.useArrows()]
  }

  // Same as BAO.Carousel's useArrows, but unbinds on destroy so recreating
  // the carousel doesn't stack up click handlers
  useArrows () {
    const next = this.els.next?.element
    const previous = this.els.previous?.element

    return carousel => {
      const goNext = () => carousel.next()
      const goPrevious = () => carousel.prev()

      next?.addEventListener('click', goNext)
      previous?.addEventListener('click', goPrevious)

      const updateButtonStates = () => {
        const { abs, maxIdx, min } = carousel.track.details

        if (next) next.disabled = abs === maxIdx
        if (previous) previous.disabled = abs === min
      }

      carousel.on('created', updateButtonStates)
      carousel.on('detailsChanged', updateButtonStates)
      carousel.on('destroyed', () => {
        next?.removeEventListener('click', goNext)
        previous?.removeEventListener('click', goPrevious)
      })
    }
  }
}

if (!customElements.get('split-hero-carousel')) {
  customElements.define('split-hero-carousel', SplitHeroCarousel)
}
